enum ActionStatus {
	PENDING = 'PENDING',
	FULFILLED = 'FULFILLED',
	REJECTED = 'REJECTED',
}

export type ThunkActionType = Record<ActionStatus, string>;

const createThunkActionType = (type: string): ThunkActionType => ({
	PENDING: `${type}/${ActionStatus.PENDING}`,
	FULFILLED: `${type}/${ActionStatus.FULFILLED}`,
	REJECTED: `${type}/${ActionStatus.REJECTED}`,
});

// Auth
export const LOGIN = {
	LOGIN: '@LOGIN/LOGIN',
	SUCCESS: '@LOGIN/SUCCESS',
	FAIL: '@LOGIN/FAIL',
};
export const LOGOUT = {
	LOGOUT: '@LOGOUT/LOGOUT',
	SUCCESS: '@LOGOUT/SUCCESS',
	FAIL: '@LOGOUT/FAIL',
};

// Init
export const INIT = {
	START: '@INIT/START',
	SUCCESS: '@INIT/SUCCESS',
	FAIL: '@INIT/FAIL',
};

// User
export const SET_ACTIVE_TEAM = 'SET_ACTIVE_TEAM';
export const SET_ACTIVE_ORGANIZATION = 'SET_ACTIVE_ORGANIZATION';

// Loading
export const SET_LOADING = 'SET_LOADING' as const;

// Popup
export const SET_MODAL = 'SET_MODAL';

// Report Story
export const GET_REPORT_STORIES = createThunkActionType('GET_REPORT_STORIES');

export const GET_BY_CARD_CSV_URL = createThunkActionType('GET_BY_CARD_CSV_URL');

export const GET_BIG_PICTURE_STORY_REPORT = {
	GET: '@GET_BIG_PICTURE_STORY_REPORT/GET',
	SUCCESS: '@GET_BIG_PICTURE_STORY_REPORT/SUCCESS',
	FAIL: '@GET_BIG_PICTURE_STORY_REPORT/FAIL',
};

export const GET_BY_CARD_STORY_REPORT = {
	GET: '@GET_BY_CARD_STORY_REPORT/GET',
	SUCCESS: '@GET_BY_CARD_STORY_REPORT/SUCCESS',
	FAIL: '@GET_BY_CARD_STORY_REPORT/FAIL',
};

// Story
export const CREATE_STORY = {
	CREATE: '@CREATE_STORY/CREATE',
	SUCCESS: '@CREATE_STORY/SUCCESS',
	FAIL: '@CREATE_STORY/FAIL',
};
export const DUPLICATE_STORY = {
	START: '@DUPLICATE_STORY/START',
	SUCCESS: '@DUPLICATE_STORY/SUCCESS',
	FAIL: '@DUPLICATE_STORY/FAIL',
};
export const DELETE_STORY = {
	START: '@DELETE_STORY/START',
	SUCCESS: '@DELETE_STORY/SUCCESS',
	FAIL: '@DELETE_STORY/FAIL',
};
export const UPDATE_LATEST_STORY = {
	UPDATE: '@UPDATE_LATEST_STORY/UPDATE',
	SUCCESS: '@UPDATE_LATEST_STORY/SUCCESS',
	FAIL: '@UPDATE_LATEST_STORY/FAIL',
};
export const STORY_ROLLBACK = {
	START: '@STORY_ROLLBACK/START',
	SUCCESS: '@STORY_ROLLBACK/SUCCESS',
	FAIL: '@STORY_ROLLBACK/FAIL',
} as const;
export const UPDATE_STORY = {
	UPDATE: '@UPDATE_STORY/UPDATE',
	SUCCESS: '@UPDATE_STORY/SUCCESS',
	FAIL: '@UPDATE_STORY/FAIL',
};
export const SET_DEFAULT_STORY_DOMAIN = {
	UPDATE: '@SET_DEFAULT_STORY_DOMAIN/UPDATE',
	SUCCESS: '@SET_DEFAULT_STORY_DOMAIN/SUCCESS',
	FAIL: '@SET_DEFAULT_STORY_DOMAIN/FAIL',
};

export const UPDATE_PUBLISHED_STORY = createThunkActionType('UPDATE_PUBLISHED_STORY');
export const UNPUBLISH_PUBLISHED_STORY = createThunkActionType('UNPUBLISH_PUBLISHED_STORY');
export const GET_STORY = createThunkActionType('GET_STORY');
export const GET_STORY_DICTIONARY = {
	GET: '@GET_STORY_DICTIONARY/GET',
	SUCCESS: '@GET_STORY_DICTIONARY/SUCCESS',
	FAIL: '@GET_STORY_DICTIONARY/FAIL',
};

export const UPDATE_STORY_URL = {
	UPDATE: '@UPDATE_STORY_URL/UPDATE',
	SUCCESS: '@UPDATE_STORY_URL/SUCCESS',
	FAIL: '@UPDATE_STORY_URL/FAIL',
};

export const UPDATE_STORY_ELEMENTS = 'UPDATE_STORY_ELEMENTS';
export const UPDATE_EDITABLE_STORY = {
	UPDATE: '@UPDATE_EDITABLE_STORY/UPDATE',
};

export const GET_STORY_AUDIENCE = createThunkActionType('GET_STORY_AUDIENCE');

// Member:
export const UPDATE_MEMBER_EMAIL = {
	UPDATE: '@UPDATE_MEMBER_EMAIL/UPDATE',
	SUCCESS: '@UPDATE_MEMBER_EMAIL/SUCCESS',
	FAIL: '@UPDATE_MEMBER_EMAIL/FAIL',
};

export const VERIFY_MEMBER_EMAIL_RESEND = {
	START: '@VERIFY_MEMBER_EMAIL_RESEND/START',
	SUCCESS: '@VERIFY_MEMBER_EMAIL_RESEND/SUCCESS',
	FAIL: '@VERIFY_MEMBER_EMAIL_RESEND/FAIL',
};

export const UPDATE_MEMBER_PASSWORD = {
	START: '@UPDATE_MEMBER_PASSWORD/START',
	SUCCESS: '@UPDATE_MEMBER_PASSWORD/SUCCESS',
	FAIL: '@UPDATE_MEMBER_PASSWORD/FAIL',
};

export const GET_MEMBER = {
	GET: '@GET_MEMBER/GET',
	SUCCESS: '@GET_MEMBER/SUCCESS',
	FAIL: '@GET_MEMBER/FAIL',
};

export const RESET_PASSWORD = {
	RESET: '@RESET_PASSWORD/RESET',
	SUCCESS: '@RESET_PASSWORD/SUCCESS',
	FAIL: '@RESET_PASSWORD/FAIL',
};

export const RESTORE_PASSWORD = {
	RESTORE: '@RESTORE_PASSWORD/RESTORE',
	SUCCESS: '@RESTORE_PASSWORD/SUCCESS',
	FAIL: '@RESTORE_PASSWORD/FAIL',
};

export const DELETE_MEMBER = {
	START: '@DELETE_MEMBER/START',
	SUCCESS: '@DELETE_MEMBER/SUCCESS',
	FAIL: '@DELETE_MEMBER/FAIL',
};

export const UPDATE_MEMBER = {
	START: '@UPDATE_MEMBER/START',
	SUCCESS: '@UPDATE_MEMBER/SUCCESS',
	FAIL: '@UPDATE_MEMBER/FAIL',
};

export const CREATE_MEMBER = {
	START: '@CREATE_MEMBER/START',
	SUCCESS: '@CREATE_MEMBER/SUCCESS',
	FAIL: '@CREATE_MEMBER/FAIL',
};

export const UPDATE_MEMBER_AVATAR = {
	START: '@UPDATE_MEMBER_AVATAR/START',
	SUCCESS: '@UPDATE_MEMBER_AVATAR/SUCCESS',
	FAIL: '@UPDATE_MEMBER_AVATAR/FAIL',
};

export const GET_MEMBER_PREFERENCES = createThunkActionType('GET_MEMBER_PREFERENCES');

export const SET_MEMBER_PREFERENCES = createThunkActionType('SET_MEMBER_PREFERENCES');

// Organization:
export const ACCEPT_INVITE_TO_ORGANIZATION = createThunkActionType('ACCEPT_INVITE_TO_ORGANIZATION');

export const UPDATE_ORGANIZATION_MEMBER = createThunkActionType('UPDATE_ORGANIZATION_MEMBER');

export const REMOVE_MEMBER_FROM_ORGANIZATION = createThunkActionType('REMOVE_MEMBER_FROM_ORGANIZATION');

export const RESEND_INVITE_TO_ORGANIZATION = createThunkActionType('RESEND_INVITE_TO_ORGANIZATION');

export const SETUP_INVITE_TO_ORGANIZATION = createThunkActionType('SETUP_INVITE_TO_ORGANIZATION');

export const GET_ORGANIZATION_TEAMS_OF_MEMBER = createThunkActionType('GET_ORGANIZATION_TEAMS_OF_MEMBER');

export const GET_ORGANIZATION_TEAMS = createThunkActionType('GET_ORGANIZATION_TEAMS');

export const GET_ORGANIZATION_ADMIN_BILLING_INFO = createThunkActionType('GET_ORGANIZATION_ADMIN_BILLING_INFO');

export const GET_ORGANIZATION_ADMIN_INVOICES_INFO = createThunkActionType('GET_ORGANIZATION_ADMIN_INVOICES_INFO');

export const UPDATE_ORGANIZATION_PAYMENT = createThunkActionType('UPDATE_ORGANIZATION_PAYMENT');

export const UPDATE_ORGANIZATION_BILLING = createThunkActionType('UPDATE_ORGANIZATION_BILLING');

export const GET_ORGANIZATION_MEMBERS = createThunkActionType('GET_ORGANIZATION_MEMBERS');

export const ADD_MEMBERS_TO_ORGANIZATION_TEAMS = createThunkActionType('ADD_MEMBERS_TO_ORGANIZATION_TEAMS');

export const VALIDATE_ORGANIZATION_NAME = createThunkActionType('VALIDATE_ORGANIZATION_NAME');

export const UPDATE_ORGANIZATION_SETTINGS = createThunkActionType('UPDATE_ORGANIZATION_SETTINGS');

export const CANCEL_SUBSCRIPTION = createThunkActionType('CANCEL_SUBSCRIPTION');

export const UPDATE_SUBSCRIPTION = createThunkActionType('UPDATE_SUBSCRIPTION');

export const GET_ORGANIZATION_DOMAINS = createThunkActionType('GET_ORGANIZATION_DOMAINS');

export const REMOVE_ORGANIZATION_DOMAIN = createThunkActionType('REMOVE_ORGANIZATION_DOMAIN');

export const RETRY_ORGANIZATION_DOMAIN_CONNECTION = createThunkActionType('RETRY_ORGANIZATION_DOMAIN_CONNECTION');

export const UPDATE_ORGANIZATION_DOMAIN = createThunkActionType('UPDATE_ORGANIZATION_DOMAIN');

export const SET_DEFAULT_ORGANIZATION_DOMAIN = createThunkActionType('SET_DEFAULT_ORGANIZATION_DOMAIN');

export const GET_ORGANIZATION_DOMAIN_STATUS = createThunkActionType('GET_ORGANIZATION_DOMAIN_STATUS');

export const GET_ORGANIZATION_STORIES = createThunkActionType('GET_ORGANIZATION_STORIES');

// Team:
export const CREATE_TEAM = {
	CREATE: '@CREATE_TEAM/CREATE',
	SUCCESS: '@CREATE_TEAM/SUCCESS',
	FAIL: '@CREATE_TEAM/FAIL',
};
export const GET_TEAM = {
	GET: '@GET_TEAM/GET',
	SUCCESS: '@GET_TEAM/SUCCESS',
	FAIL: '@GET_TEAM/FAIL',
};
export const UPDATE_TEAM = {
	UPDATE: '@UPDATE_TEAM/UPDATE',
	SUCCESS: '@UPDATE_TEAM/SUCCESS',
	FAIL: '@UPDATE_TEAM/FAIL',
};
export const GET_TEAM_STORIES = {
	GET: '@GET_TEAM_STORIES/GET',
	SUCCESS: '@GET_TEAM_STORIES/SUCCESS',
	FAIL: '@GET_TEAM_STORIES/FAIL',
};
export const GET_TEAM_MEMBERS = {
	GET: '@GET_TEAM_MEMBERS/GET',
	SUCCESS: '@GET_TEAM_MEMBERS/SUCCESS',
	FAIL: '@GET_TEAM_MEMBERS/FAIL',
};
export const UPDATE_TEAM_MEMBER = {
	UPDATE: '@UPDATE_TEAM_MEMBER/UPDATE',
	SUCCESS: '@UPDATE_TEAM_MEMBER/SUCCESS',
	FAIL: '@UPDATE_TEAM_MEMBER/FAIL',
};
export const DELETE_TEAM_MEMBER = {
	DELETE: '@DELETE_TEAM_MEMBER/DELETE',
	SUCCESS: '@DELETE_TEAM_MEMBER/SUCCESS',
	FAIL: '@DELETE_TEAM_MEMBER/FAIL',
};
export const DELETE_TEAM = {
	DELETE: '@DELETE_TEAM/DELETE',
	SUCCESS: '@DELETE_TEAM/SUCCESS',
	FAIL: '@DELETE_TEAM/FAIL',
};

// Plans
export const GET_PLANS = {
	GET: '@GET_PLANS/GET',
	SUCCESS: '@GET_PLANS/SUCCESS',
	FAIL: '@GET_PLANS/FAIL',
};

export const GET_PLAN_CHARGE_INFO = {
	GET: '@GET_PLAN_CHARGE_INFO/GET',
	SUCCESS: '@GET_PLAN_CHARGE_INFO/SUCCESS',
	FAIL: '@GET_PLAN_CHARGE_INFO/FAIL',
};

// Templates
export const GET_TEMPLATES = createThunkActionType('GET_TEMPLATES');

// Version
export const SET_VERSION = 'SET_VERSION';

// Card Editor
export const SET_EDITABLE_EDITOR_ELEMENT = 'SET_EDITABLE_EDITOR_ELEMENT';
export const SET_EDITABLE_ELEMENT_MODE = 'SET_EDITABLE_ELEMENT_MODE';
export const SET_EDITOR_CURRENT_MEDIA_QUERY = 'SET_EDITOR_CURRENT_MEDIA_QUERY';
export const SET_EDITABLE_STATE = 'SET_EDITABLE_STATE';
export const SET_EDITOR_SIZE = 'SET_EDITOR_SIZE';
export const UPDATE_EDITABLE_CARD_DATA = 'UPDATE_EDITABLE_CARD_DATA';
export const UPDATE_EDITABLE_CARD_IN_STORY = 'UPDATE_EDITABLE_CARD_IN_STORY';
export const RESET_EDITABLE_CARD = 'RESET_EDITABLE_CARD';
export const REMOVE_STORY_FLOAT_REFERENCES = 'REMOVE_STORY_FLOAT_REFERENCES';
export const ADD_STORY_FLOAT_REFERENCES = 'ADD_STORY_FLOAT_REFERENCES';
export const CARD_EDITOR_UNMOUNT_LOADING = 'CARD_EDITOR_UNMOUNT_LOADING';
export const CARD_EDITOR_SYNC = {
	DRAFT: '@CARD_EDITOR_SYNC/DRAFT',
	SYNC: '@CARD_EDITOR_SYNC/SYNC',
	FAIL: '@CARD_EDITOR_SYNC/FAIL',
	SUCCESS: '@CARD_EDITOR_SYNC/SUCCESS',
} as const;
export const STORY_EDITOR_SYNC = {
	DRAFT: '@STORY_EDITOR_SYNC/DRAFT',
	SYNC: '@STORY_EDITOR_SYNC/SYNC',
	FAIL: '@STORY_EDITOR_SYNC/FAIL',
	SUCCESS: '@STORY_EDITOR_SYNC/SUCCESS',
} as const;
export const STORY_EDITOR_UNMOUNT = '@STORY_EDITOR/UNMOUNT';
export const CARD_EDITOR_UNMOUNT = '@CARD_EDITOR/UNMOUNT';
export const APPLY_STORY_VOLUNTARY_UPDATES = {
	START: '@APPLY_STORY_VOLUNTARY_UPDATES/START',
	SUCCESS: '@APPLY_STORY_VOLUNTARY_UPDATES/SUCCESS',
	FAIL: '@APPLY_STORY_VOLUNTARY_UPDATES/FAIL',
};
